import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .01,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 16V-9.53674e-07H16V16H0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.32828 13.5003H2.49985V10.6719L10.6716 2.5L13.5 5.32843L5.32828 13.5003Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 4L12 7",
			stroke: "currentColor"
		})
	]
});
export default SvgEdit;
